var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-badge",
    { attrs: { overlap: "" } },
    [
      _vm.isTyping && _vm.chip
        ? _c("span", { staticClass: "badgeTyping primary" }, [
            _c("div", { staticClass: "WatchBox-istyping_BO" }, [
              _c("div", { staticClass: "bounce1" }),
              _vm._v(" "),
              _c("div", { staticClass: "bounce2" }),
              _vm._v(" "),
              _c("div", { staticClass: "bounce3" })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.lastMessage
        ? _c("span", { attrs: { slot: "badge" }, slot: "badge" }, [_vm._v("!")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-avatar",
        { class: _vm.colorComputed, attrs: { tile: _vm.tile, size: _vm.size } },
        [
          _vm.srcData
            ? _c("img", {
                attrs: { src: _vm.srcData },
                on: { error: _vm.error, load: _vm.loaded }
              })
            : _vm.username[0] == "#"
            ? _c(
                "v-icon",
                {
                  staticClass: "white",
                  style: "font-size: " + _vm.size + " !important;",
                  attrs: { color: _vm.colorComputed }
                },
                [_vm._v("account_circle")]
              )
            : _c(
                "span",
                { staticClass: "white--text", class: [_vm.classOfTitle] },
                [_vm._v(_vm._s(_vm.usernameComputed))]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-381854e6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381854e6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAvatar.vue
// module id = null
// module chunks = 